import React from 'react'

const EHRCaseStudyHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5 py-28 bg-bgDefault text-white ">
            <div className='container xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-12 gap-8'>
                    <div className='col-span-12 md:col-span-6'>
                        <h2 className="text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 ">
                            Academic EHR Training Solution
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Java
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Angular
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                PostgreSQL
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                AWS
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto ">
                              We partnered with a leading US Electronic Health Record (EHR) solution provider to revolutionize medical education
                              through an innovative academic EHR training platform. This cutting-edge system successfully simulates real-world
                              medical charting and patient management in a secure, controlled environment, empowering over 10,000 medical students,
                              faculties, and preceptors to master clinical workflows before entering actual healthcare settings. The platform has
                              become an essential bridge between classroom theory and clinical practice, reducing the learning curve by 30% and
                              facilitating 5,000+ online practical examinations with zero data breaches.
                            </p>

                    </div>
                    <div className='col-span-12 md:col-span-6'>
                      <img src='/case_studies/title-banner/ehr-app-title-banner.png' alt='Academic EHR Training Solution' className='w-full h-auto'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EHRCaseStudyHero
